import { MenuItemCategory, MenuItemType } from "../../../../Components/navigationTypes";
import { CONST } from "../../../../SideDrawer/sideTypes";

export const drDetailsList: Array<MenuItemType> = [
    {
        label: "Contract",
        navigate: {
            component: "main",
        },
        subItems: [
            {
                label: "Basic",
                navigate: {
                    component: "main",
                    reactFrame: "contract",
                    params: {
                        id: CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 0,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Contract,
            },
            {
                label: "Property",
                navigate: {
                    component: "main",
                    params: {
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Basic",
                        tabNumber: 1,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Property
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
    {
        id: "Buyer",
        label: "Buyer Side",
        PSM: "PSO",
        navigate: {
            component: "main",
        },
        addOptions: [],
        expandable: true,
        type: MenuItemCategory.Heading
    },
    {
        id: "Seller",
        label: "Seller Side",
        PSM: "PSO",
        navigate: {
            component: "main",
        },
        addOptions: [],
        expandable: true,
        type: MenuItemCategory.Heading,
    },
    {
        label: "Mortgage",
        navigate: {
            component: "main"
        },
        addOptions: [],
        expandable: true,
        type: MenuItemCategory.Heading
    }
]